
import Popup from "../../components/popup/popup-v2.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import store from "../../core/store";
import { LocalStorage } from "@shared/core/localStorage";
import { Settings } from "../../core/services/configService";
import { CrudService } from "../../core/services/crudService";
import { Format } from "@shared/core/helpers/formatHelper";
import { ShopService } from "@shared/core/services/shopService";
import SubmitButton from "../submitButton/submitButton.vue";
import { DateHelper } from "@shared/core/helpers/dateHelper";


@Component({
  components: {
    Popup,
    SubmitButton
  },
})
export default class PopupConfirmByPlace extends Vue {
  @Prop({ required: true, type: Object }) private bookingSelected!: any;
  @Prop({ required: false }) private title!: string;
  private errorMsg: string = "";
  private get popupTitle() {
    return this.title || this.$t('Play a match');
  }
  private get summary() {
    const dateStr = DateHelper.toServerFormat(
      DateHelper.toDate(
        this.bookingSelected.date,
        this.$store.state.settings.DateFormat
      )!
    );
    return [
      {
        title: this.$t('Duration'),
        icon: this.isDarkMode ? require('@/images/icons/timer-white.svg') : require('@/images/icons/timer-black.svg'),
        text: this.bookingSelected.duration,
      },
      {
        title: this.$t('Date'),
        icon: this.isDarkMode ? require('@/images/clock-icon.svg') :require('@/images/clock-black-icon.svg'),
        text: `${DateHelper.beautifyDate(dateStr, true, false, true, false)} | ${DateHelper.extractTime(this.bookingSelected.startHour)}`,
      },
      {
        title: this.$t('Level'),
        icon: this.isDarkMode ? require('@/images/icons/level-white.svg') :require('@/images/icons/level-black.svg'),
        text: this.bookingSelected.modifyLevel ? this.$t("Competitive") : this.$t("Friendly"),
      },
      {
        title: this.$t('Resource'),
        icon: this.isDarkMode ? require('@/images/icons/location-white.svg') : require('@/images/icons/location-black.svg'),
        text: this.bookingSelected.resources.join(),
      },
    ]
  };
  
  private get isDarkMode() {
    return store.state.settings.DarkMode === true;
  }
  
  async addToCart(e: MouseEvent) {
    this.errorMsg = "";
    let cid = 0;
    let sid = LocalStorage.getWithTimeout("cc");
    if (sid !== undefined && sid !== null) {
      cid = JSON.parse(sid).id;
    }
    if (cid === 0 || cid === null) {
      this.errorMsg = this.$t("Please login or register").toString();
      return;
    }

    const bookingId = this.bookingSelected.id;
    if (bookingId === null || bookingId === undefined) {
      this.errorMsg = this.$t("crash").toString();
      return;
    }

    let url = `${
      Settings.HostName
    }/api/publicbookings/byplace-prebook-place/${cid}/${bookingId}/${Format.getOrigin()}`;
    if (this.$route.query.placeId !== undefined) {
      url += "/" + this.$route.query.placeId;
    }
    const res = await new CrudService().httpPost(url, {});

    if (res == null || res == undefined) {
      console.error("Crash getting bookings by place");
      this.errorMsg = this.$t("Crash").toString();
      return;
    }
    if (res.ok === false) {
      this.errorMsg = res.errorMsg;
      return;
    }

    if (res.model.serviceFree === true) {
      return this.$router.push("/customer-bookings");
    }

    let sale = res.model;
    sale.title = sale.description;
    sale.cancelUrl = `publicbookings/cancel/${bookingId}/${cid}`;

    new ShopService().addSaleToCart(sale, e.currentTarget);
    this.$router.push("/checkout");
  }

  getMatchPrice(price: string, netPrice: string) {
    return store.state.settings.PriceWithTaxes
      ? Format.formatCurrency(price)
      : Format.formatCurrency(netPrice);
  }
}
